import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { WalletListInterface } from '../../types/wallet-list';
import {
  WalletListFilter,
  defaultWalletListFilter,
} from '../../types/wallet-list-filter';

export const PARTNER_WALLET_LIST_STATE = 'partnerWalletList';

export interface PartnerWalletListState {
  filter: WalletListFilter;
  dataSource: DataSource<WalletListInterface[]>;
}

export const initialDataSource: DataSource<WalletListInterface[]> =
  Object.freeze({
    ...initialPageableData,
    rawData: [],
  });

export const initialPartnerWalletListState: PartnerWalletListState =
  Object.freeze({
    filter: defaultWalletListFilter,
    dataSource: {
      ...initialDataSource,
    },
  });
